module.exports = __webpack_public_path__ + "images/86a83301.img_cht_win_1.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/img_cht_win_1.jpg
// module id = 329
// module chunks = 0